import { INVENTORY_LEVEL, type InventoryLevel } from '@fdh/shared';

export type InventoryUiTranslateFn = (
  key: string,
  params?: Record<string, string | number>,
) => string;

/** Maps persisted inventory level to localized short label (same keys as wizard UI). */
export const inventoryStockLevelUiLabel = (
  level: InventoryLevel,
  t: InventoryUiTranslateFn,
): string => {
  switch (level) {
    case INVENTORY_LEVEL.FULL:
      return t('inventory.level.full');
    case INVENTORY_LEVEL.HALF:
      return t('inventory.level.half');
    case INVENTORY_LEVEL.LOW:
      return t('inventory.level.low');
    case INVENTORY_LEVEL.EMPTY:
      return t('inventory.level.empty');
    default:
      return t('inventory.level.unknown');
  }
};
